import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';
import { lightGrey2Color } from 'js/config/style';

const Container = animated(styled.div`
  position: relative;
  border: solid 1px ${lightGrey2Color.hex()};
  border-radius: 0.25rem;
  background: white;
  display: grid;
`);

export default ({ noAnimation, ...rest }) => {
  return typeof noAnimation === 'undefined' || noAnimation === false ? (
    <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
      {animation => (
        <animated.div style={animation}>
          <Container {...rest} />
        </animated.div>
      )}
    </Spring>
  ) : (
    <Container {...rest} />
  );
};
